import { SxProps } from '@mui/system';
import { Theme } from 'theme';

export const popupContainerStyle: SxProps<Theme> = theme => ({
	display: 'flex',
	flexDirection: 'column',
	padding: theme.spacing(1, 2.5, 0.5),
	backgroundColor: theme.palette.background.paper,
});
